import React from 'react';
import { Search } from 'lucide-react';

export default function FiltrosBusqueda({
  searchTerm, setSearchTerm,
  estados,
  filtroEstadoId, setFiltroEstadoId,
  mostrarSoloNuevos, setMostrarSoloNuevos,
  mostrarSoloMias, setMostrarSoloMias,
  mostrarSoloActivas, setMostrarSoloActivas
}) {
  return (
    <div className="animate-fade-in" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '1.5rem', gap: '1rem', flexWrap: 'wrap' }}>
      <div style={{ position: 'relative', width: '100%', maxWidth: 440 }}>
        <Search size={17} style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: 'var(--text-muted)' }} />
        <input type="text" placeholder="Buscar por nombre, RUT o número de seguimiento..."
          value={searchTerm} onChange={e => setSearchTerm(e.target.value)}
          style={{ paddingLeft: 38, borderRadius: 24, background: 'var(--bg-surface)' }} />
      </div>

      <div style={{ display: 'flex', alignItems: 'center', gap: '1rem', flexWrap: 'wrap' }}>
        {/* Filtro por Estado */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
          <span style={{ fontSize: '0.85rem', fontWeight: 600, color: 'var(--text-muted)' }}>Estado:</span>
          <select
            value={filtroEstadoId}
            onChange={(e) => setFiltroEstadoId(e.target.value)}
            style={{
              padding: '6px 12px',
              borderRadius: '12px',
              background: 'var(--bg-surface)',
              border: '1px solid var(--border-color)',
              fontSize: '0.85rem',
              color: 'var(--text-main)',
              minWidth: '160px'
            }}
          >
            <option value="">Todos los estados</option>
            {estados.map(est => (
              <option key={est.id} value={est.id}>{est.nombre}</option>
            ))}
          </select>
        </div>

        <label className="switch-container">
          <input type="checkbox" className="switch-input" checked={mostrarSoloNuevos} onChange={e => setMostrarSoloNuevos(e.target.checked)} />
          <div className="switch-track" style={mostrarSoloNuevos ? { background: '#ef4444' } : {}}>
            <div className="switch-thumb"></div>
          </div>
          <span style={{ fontSize: '0.85rem', fontWeight: 600, color: 'var(--text-muted)' }}>Solo Nuevas Respuestas</span>
        </label>

        <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center' }}>
          <label style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            background: mostrarSoloMias ? 'var(--primary-light)' : '#f1f5f9',
            color: mostrarSoloMias ? 'white' : 'var(--text-main)',
            padding: '0.6rem 1.2rem',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '0.9rem',
            fontWeight: 600,
            transition: 'all 0.2s',
            whiteSpace: 'nowrap'
          }}>
            <input
              type="checkbox"
              checked={mostrarSoloMias}
              onChange={(e) => setMostrarSoloMias(e.target.checked)}
              style={{ width: '16px', height: '16px' }}
            />
            Mis Solicitudes
          </label>

          <label style={{
            display: 'flex',
            alignItems: 'center',
            gap: '10px',
            background: mostrarSoloActivas ? '#fee2e2' : '#f1f5f9',
            color: mostrarSoloActivas ? '#991b1b' : 'var(--text-main)',
            padding: '0.6rem 1.2rem',
            borderRadius: '8px',
            cursor: 'pointer',
            fontSize: '0.9rem',
            fontWeight: 600,
            transition: 'all 0.2s',
            whiteSpace: 'nowrap'
          }}>
            <input
              type="checkbox"
              checked={mostrarSoloActivas}
              onChange={(e) => setMostrarSoloActivas(e.target.checked)}
              style={{ width: '16px', height: '16px' }}
            />
            Ocultar Finalizadas
          </label>
        </div>
      </div>
    </div>
  );
}
